<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre2"><span id="Page_23" title="[Pg 23]"></span></p>
<h2 class="nobreak" id="CHAPTER_III">CHAPTER III<br class="calibre4"/>
<span class="fs3">WONDERFUL NEWS</span></h2>
</div>
<p class="calibre2">Bunny Brown and his sister Sue made a
rush for the hall to meet their father. In
fact, they always ran to meet him as soon as
they heard him enter the house. But this time,
because he called out that he had great news
for them, there was an extra reason for hurrying.</p>
<p class="calibre2">“Don’t make too much noise, my dears,”
said Mrs. Brown, motioning to the injured
sailor.</p>
<p class="calibre2">“He doesn’t hear them,” said Uncle Tad,
who was sitting beside Mr. Pott. “He’s off
in a stupor now. I’m afraid he’s going to be
a very sick man.”</p>
<p class="calibre2">“Too bad,” murmured Mrs. Brown. “If
we could only find his son and get word to
him about his father.”</p>
<p class="calibre2">“Likely the son will never be found,” replied
Uncle Tad in a low voice.</p>
<p class="calibre2"><span id="Page_24" title="[Pg 24]"></span></p>
<p class="calibre2">“Well, we’ll take care of this poor man
until Dr. Rudd sees him again,” went on
Mrs. Brown. “By that time he may be better.”</p>
<p class="calibre2">Bunny and Sue found their father out in the
hall. Generally they rushed at him with
merry peals of laughter and jolly shouts. But
now they had heard what their mother said
about disturbing Mr. Pott, so they were a little
quieter.</p>
<p class="calibre2">“What’s the great news, Daddy?” asked
Bunny.</p>
<p class="calibre2">“Are we going away somewhere?” Sue
wanted to know. To travel was the delight
of the two children, and nothing pleased them
so much as to be on the move—it did not much
matter where, as long as they were seeing
something new. But probably most children
are like that.</p>
<p class="calibre2">“Yes, I think perhaps we are going away—on
the rolling ocean,” said Mr. Brown. “I’ll
tell you more about it in a little while. But
what is going on here? Some one told me
there had been an accident here, though I see
it isn’t either of you two who is hurt. And it<span id="Page_25" title="[Pg 25]"></span>
can’t be mother, for I hear her talking to
Uncle Tad.”</p>
<p class="calibre2">“It’s Mr. Pott,” explained Bunny. “He’s
a sailor and he lost his son Harry and the
treasure and he was on a horse.”</p>
<p class="calibre2">“But he fell off the horse,” quickly added
Sue. “And, Daddy, he ’most fell on us when
we played store!”</p>
<p class="calibre2">“My! I should say that was a lot to have
happen to one,” said Mr. Brown. “Now
don’t make too much noise if we have a sick
man in the house.”</p>
<p class="calibre2">He went into the room where his wife and
Uncle Tad were keeping watch over Mr. Pott,
and from Mrs. Brown soon learned all there
was to know about the matter.</p>
<p class="calibre2">“Too bad,” said Mr. Brown. “Well, perhaps
things may turn out all right after all,
but it’s pretty hard for the old man to lose his
son and a treasure at the same time.”</p>
<p class="calibre2">Making the sailor as comfortable as possible,
and leaving Uncle Tad to watch over him,
Mr. and Mrs. Brown and the children went
to another room where they could talk together.</p>
<p class="calibre2"><span id="Page_26" title="[Pg 26]"></span></p>
<p class="calibre2">“What’s this about some news the children
say you have?” asked Mrs. Brown.</p>
<p class="calibre2">“It is news, yes, in a way,” answered her
husband. “How would you like to take a
trip?”</p>
<p class="calibre2">“It depends on where the trip is,” his wife
said, with a smile. “If I had my choice I
would like to go down south where it is lovely
and warm and where there are so many flowers
and birds.”</p>
<p class="calibre2">“You must have guessed what I was going
to say,” laughed Mr. Brown, “for down south
is where I was thinking of going.”</p>
<p class="calibre2">“Is it down to the sunny south where we
were once before?” asked Bunny. The Brown
children had once taken a trip to the southland.</p>
<p class="calibre2">“Not exactly the same place,” Mr. Brown
replied. “Of course, the south is always
sunny, but this time I have in mind an ocean
voyage. I have to go to the West Indies on
business, and I have a chance to go on a
steamer which one of the big fish companies
is sending. They have given me the use of
two staterooms, so there will be room for all of<span id="Page_27" title="[Pg 27]"></span>
us. If you want to go and take the children,
my dear,” he said to his wife, “I think it
would be a pleasant trip for us all.”</p>
<p class="calibre2">“I don’t see how we could very well leave
them at home,” remarked Mrs. Brown, looking
at Bunny and Sue.</p>
<p class="calibre2">“Leave us at home? I guess not!” cried
Bunny. “I wouldn’t stay!”</p>
<p class="calibre2">“And if Bunny doesn’t stay at home I’m not
going to stay!” announced Sue, almost ready
to cry.</p>
<p class="calibre2">“There, now, don’t get excited,” laughed
Mr. Brown. “No one is going to be left at
home.”</p>
<p class="calibre2">“And are we really going on the ocean?”
asked Bunny.</p>
<p class="calibre2">“To get to the West Indies down near Cuba
we must go on the ocean,” answered Mr.
Brown. “But though the ocean may roll a bit,
it will not be very rough, if that’s what you’re
thinking of.”</p>
<p class="calibre2">“Tell me more about it,” begged Mrs.
Brown, while the children listened.</p>
<p class="calibre2">“Well, it isn’t all settled yet,” Mr. Brown
replied. “But, as you know, I sell some of<span id="Page_28" title="[Pg 28]"></span>
my fish to the Empire Sea Food Company of
Philadelphia. One of their men was in to see
me the other day and told of an especial trip
one of their steamers was going to make to the
West Indies. They are to look up new places
from which they may have southern fish
shipped to them. This man said there would
be plenty of room on the <em class="calibre6">Beacon</em>, which is the
name of the steamer. She isn’t going to carry
regular passengers, just the crew, some members
of the fish company, and some of the
wives of the officers of the company.</p>
<p class="calibre2">“So, as he offered me the use of two staterooms,
which will be just enough for us, I
thought perhaps you and the children might
like to go. I can leave my head clerk and
Bunker Blue in charge of my business here,
and Uncle Tad can look after the house. So
there is no reason why we can’t all go on the
rolling ocean.”</p>
<p class="calibre2">“I think I should love it,” said Mrs. Brown.</p>
<p class="calibre2">“Are we going to-morrow?” Sue wanted to
know. “’Cause if we are, I’ve got to put a
new dress on my doll.”</p>
<p class="calibre2">“Oh, no, we won’t go to-morrow!” laughed<span id="Page_29" title="[Pg 29]"></span>
her father. “Perhaps not for a week yet.
You’ll have plenty of time to dress Sallie Ann,
if that’s the name of your doll.”</p>
<p class="calibre2">“No,” said Sue, thinking the matter over,
“I haven’t any doll named Sallie Ann. But,”
she added quickly, “if you would get me a new
doll I could name her Sallie Ann.”</p>
<p class="calibre2">“Oh, ho, you little tyke! So that’s what
you’re thinking of, are you?” exclaimed Mr.
Brown, catching Sue up in his arms. “Well,
we’ll see about the new doll later on. But if
you think it is settled about making the trip,
I’ll send word to Captain Ward of the <em class="calibre6">Beacon</em>
so our staterooms will be made ready.”</p>
<p class="calibre2">“Yes, I think we’ll take the trip,” said Mrs.
Brown.</p>
<p class="calibre2">Just then Sue called:</p>
<p class="calibre2">“Oh, look at Bunny! What’s he doing?”</p>
<p class="calibre2">Well might she ask that, for Bunny was
moving about the room, reeling from side to
side, heaving and rolling his shoulders and
head as though trying to turn himself inside
out.</p>
<p class="calibre2">“Bunny! What’s the matter?” called his
mother. “Are you ill?”</p>
<p class="calibre2"><span id="Page_30" title="[Pg 30]"></span></p>
<p class="calibre2">“No, I’m not sick!” replied Bunny, straightening
up. “I’m just making believe I’m on a
ship on the rolling ocean. The ocean rolls,
daddy said, and I’m rolling. I’m on the rolling
ocean! The rolling ocean!” With a
laugh, Bunny again made his shoulders move
in that funny way, imitating the heaving and
swaying of a ship in the swell of the sea.</p>
<p class="calibre2">“You’ll get plenty of that before we reach
the West Indies,” said Mr. Brown. “The
ocean will roll for you all you want it to.”</p>
<p class="calibre2">“I like the ocean,” announced the little boy.
“I’m going to fish in it when we get on the
steamer.”</p>
<p class="calibre2">“And maybe you’ll catch a crab and it will
pinch you,” said Sue.</p>
<p class="calibre2">“I like crabs,” declared Bunny.</p>
<p class="calibre2">“I don’t,” stated Sue. “I don’t like ’em
alive! Once I got pinched by a crab.” This
was true. The children had gone out fishing
in Sandport Bay with Bunker Blue once upon
a time. A crab had been caught and before
Sue could get out of the way of the queer,
sidewise-moving creature, it had nipped her
on the leg.</p>
<p class="calibre2"><span id="Page_31" title="[Pg 31]"></span></p>
<p class="calibre2">“Well, since it is all settled that we are to
go on the rolling ocean,” announced Mr.
Brown, “I’ll send word to Captain Ward. He
asked me to let him know, and—”</p>
<p class="calibre2">“Hark!” suddenly exclaimed Mrs. Brown,
holding up her hand for silence.</p>
<p class="calibre2">A noise sounded in the other room where
Mr. Pott had been put. The voice of the
sailor could be heard murmuring, and Uncle
Tad was answering him.</p>
<p class="calibre2">“I must see what’s the matter,” said Mrs.
Brown.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?86740c80